import { GenericSnippet } from '../../contexts/SettingsContext.d'
import { Dispatch, PrimaryAction, ProgressTrackerAction } from './Action.d'

/* Settings actions */

export const SETTINGS_INSTANCE_IDS = [
    'diary_production', 'diary_flash',
    'gocd_testing', 'fac_legacy', 'prepare',
    'diary_production_db', 'diary_flash_db'] as const
export type SettingsInstanceId = typeof SETTINGS_INSTANCE_IDS[number]
// Instances auto-checked together in one batched call. prepare auto-checks too, but via its own lambda.
export const SETTINGS_INSTANCE_IDS_AUTOCHECK: SettingsInstanceId[] = [
    'diary_production', 'diary_flash_db', 'diary_flash', 'fac_legacy']
export const SETTINGS_SYNC_APIS = ['fitbit', 'rescuetime'] as const
export type SettingsSyncApi = typeof SETTINGS_SYNC_APIS[number]

type CheckPrepareStatusAction = {
    type: 'CHECK_PREPARE_STATUS'
    instanceId: SettingsInstanceId
}
type CheckInstanceStateAction = {
    type: 'CHECK_INSTANCE_STATE'
    // One instance, or several to check together in a single batched instance_control call.
    instanceId: SettingsInstanceId | SettingsInstanceId[]
}
type ResetInstanceStatusAction = {
    type: 'RESET_INSTANCE_STATUS'
    instanceId: SettingsInstanceId
}
export type CheckInstanceAction = CheckPrepareStatusAction | CheckInstanceStateAction
type SetWindowFocusedAction = {
    type: 'SET_WINDOW_FOCUSED'
    focused: boolean
}
type TriggerPrepareAction = {
    type: 'TRIGGER_PREPARE'
    instanceId: SettingsInstanceId
}
type ToggleInstanceAction = {
    type: 'TURN_INSTANCE_ON' | 'TURN_INSTANCE_OFF'
    instanceId: SettingsInstanceId
}

type RetrieveSnippetsAction = {
    type: 'RETRIEVE_SNIPPETS'
}
export type DeleteSnippetAction = {
    type: 'DELETE_SNIPPET'
    snippet: GenericSnippet
    /** The value of the field to be deleted. Used only when deleting aliases */
    value: string
}
export type CacheModifySnippetAction = {
    type: 'CACHE_MODIFY_SNIPPET'
    original: GenericSnippet
    field: string
    oldValue: string
    newValue: string
}
type ModifySnippetAction = Omit<CacheModifySnippetAction, 'type'> & {
    type: 'MODIFY_SNIPPET'
}

export type CacheCreateSnippetAction = {
    type: 'CACHE_CREATE_SNIPPET'
    snippet: GenericSnippet
}
type CreateSnippetAction = {
    type: 'CREATE_SNIPPET'
    snippet: GenericSnippet
}

type GetSyncLoginUrlAction = {
    type: 'GET_SYNC_LOGIN_URL'
    api: 'fitbit'
}
export type SyncFitbitAuthCallbackAction = {
    type: 'SYNC_FITBIT_AUTH_CALLBACK'
    api: 'fitbit'
    code: string
    appDispatch: Dispatch
}
type UnlinkSyncApiAction = {
    type: 'UNLINK_SYNC_API'
    api: SettingsSyncApi
    appDispatch: Dispatch<PrimaryAction>
}
type TriggerSyncAction = {
    type: 'TRIGGER_SYNC'
    api: SettingsSyncApi
}
type SyncCallInitiatedAction = {
    type: 'SYNC_CALL_INITIATED'
    api: SettingsSyncApi
    request?: 'authUrl'
}
export type SettingsAction = CheckInstanceAction | ResetInstanceStatusAction
  | TriggerPrepareAction | ToggleInstanceAction | SetWindowFocusedAction
  | RetrieveSnippetsAction | DeleteSnippetAction
  | CacheModifySnippetAction | ModifySnippetAction
  | CacheCreateSnippetAction | CreateSnippetAction
  | GetSyncLoginUrlAction | UnlinkSyncApiAction | TriggerSyncAction
  | SyncCallInitiatedAction | SyncFitbitAuthCallbackAction | ProgressTrackerAction
